//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
  hideLoading,
  showLoading,
} from 'counselor-mobile-ui/utils/ui/loading'
import { CatEmpty } from 'counselor-mobile-ui'
import { dayjs } from 'counselor-mobile-ui/utils/feature/date'
import { getShareDetail } from '../../services/share.services'
import CatPersonalModal from '@/components/cat-personal-modal'
import {
  STATUS,
  STATUS_CONF,
  TERMINATION_STATUS,
} from '@/public/config/statusConf'
import CatStatusFlag from '@components/cat-status-flag'
import CatStatusShow from '@components/cat-status-show'
import CatFlowLeaveMeta from '@components/cat-flow-leave-meta'
import CatExtendDetail from '@components/cat-extend-detail'
import CatLeaveDetail from '@components/cat-leave-detail'
import CatCompleteInfo from '@components/cat-complete-info'
import {
  formatDate,
  getUrlParams,
} from '@/utils/utils'

export default {
  components: {
    CatStatusFlag,
    CatStatusShow,
    CatFlowLeaveMeta,
    CatExtendDetail,
    CatLeaveDetail,
    CatCompleteInfo,
    CatEmpty,
    CatPersonalModal,
  },

  data () {
    return {
      isShared: true,
      leaveId: '',

      info: {},
      statusFlag: null,

      // 提前结束假期信息
      terminationInfo: {
        allowTerminate: 0, // 是否可以提前结束当前请假记录：0-不可以;1-可以
        terminated: 0, // 是否已经提前结束当前请假记录：0-没有;1-已经提前结束
        terminationObjectName: '', // 提前结束操作人员名称
        terminationReason: '', // 提前结束原因
      },

      // 销假规则信息
      notOutReport: {
        operatorDate: null,
        operatorId: null,
        operatorName: null,
        operatorWid: null,
        rule: 0,
        setedNotOutReport: 0, // 是否已经有人操作过非离校销假设置
      },
      isAllowedExtend: false, // 是否允许续假
      isReport: '0', // 是否允许销假
      isOpenExt: '0', // 是否开通续假功能 '0', '1'
      leaveExtends: [],
      flowBiz: true,
      approvers: [],
      approversMain: null,
      isEmpty: false,
      emptyText: '暂无数据',
      nowTime: '',
      needApproval: null,
      show: false,
      studentInfo: {},
    }
  },

  computed: {
    // 是否已提前结束状态
    terminatedEarlyStatus () {
      return this.terminationInfo.terminated
    },

    // 是否已经提前结束
    isTerminatedEarly () {
      return this.terminatedEarlyStatus === TERMINATION_STATUS.TERMINATED.YES
    },

    successInfo () {
      if (this.info.status === STATUS.PROCESSING || this.info.status === STATUS.COMPLETE) {
        return [this.info]
      } else {
        return []
      }
    },

    successLeaveExtends () {
      return this.leaveExtends.filter((it) => it.status === STATUS.PROCESSING || it.status === STATUS.COMPLETE || it.status === STATUS.REJECT)
    },

    leaveStatus () {
      return this.info.status
    },

    lastExt () {
      // 获取最后一条续假
      const len = this.leaveExtends.length

      return len > 0 ? this.leaveExtends[len - 1] : null
    },

    lastExtStatus () {
      // 获取最后一条续假状态
      return this.lastExt ? this.lastExt.status : null
    },

    haveExt () {
      return this.leaveExtends.length > 0
    },

    approveStatus () {
      const mainStatus = this.info.status

      // 请假记录为已完成或销假逾期，直接返回主请假状态
      if (mainStatus === STATUS.COMPLETE || mainStatus === STATUS.EXCEED) {
        return mainStatus
      }

      return this.lastExtStatus || mainStatus
    },

    visDesBtn () {
      return this.isReport === '1'
    },

    isComplete () {
      return this.leaveStatus === STATUS.COMPLETE
    },

    isPending () {
      return this.leaveStatus === STATUS.PENDING || this.lastExtStatus === STATUS.PENDING
    },

    isProcessing () {
      return this.leaveStatus === STATUS.PROCESSING
    },

    isLeaveReject () {
      return this.leaveStatus === STATUS.REJECT
    },

    isExtReject () {
      return this.lastExtStatus === STATUS.REJECT
    },

    statusInfo () {
      return STATUS_CONF[this.approveStatus] || {}
    },

    extBtnText () {
      return this.isExtReject ? '重新申请续假' : '申请续假'
    },

    hideBottom () {
      return { 'bottom-0': !this.isLeaveReject && !this.isPending }
    },
  },

  created () {
    this.initPage()
  },

  methods: {
    showInfoModal () {
      this.show = true
    },

    closeModal () {
      this.show = false
    },

    getApproveNodes (approvers) {
      return approvers && approvers.filter((item) => {
        return item.approveNode.length > 0 && !!item.approveNode[0].nodeWid
      })
    },

    getNowTime (time) {
      let times = dayjs(time).valueOf()

      setInterval(() => {
        times += 1000
        this.nowTime = `当前时间:${formatDate(times, 'yyyy-MM-dd hh:mm:ss')}`
      }, 1000)
    },

    async initPage () {
      const params = getUrlParams()
      this.needApproval = params.needApproval === '0' || params.needApproval === 0 ? 0 : 1

      showLoading()
      const { data, code } = await getShareDetail({
        ...params,
        uaIsCpadaily: sessionStorage.uaIsCpadaily,
      })

      hideLoading()
      if (code === '2210060000') {
        this.isEmpty = true
        this.emptyText = '暂无数据'

        return
      }

      this.info = data.detail || {}
      this.studentInfo = data.studentInfo || {}

      const times = data.nowTime || new Date()

      this.nowTime = `当前时间:${formatDate(times, 'yyyy-MM-dd hh:mm:ss')}`

      this.getNowTime(times)
      this.statusFlag = data.recordStatus || ''

      // 销假规则信息
      this.notOutReport = data.notOutReport || {}
      this.terminationInfo = data.termination || {}
      this.leaveExtends = data.leaveExtends || []
      this.isOpenExt = data.isExtend
      this.isReport = data.isReport

      this.isAllowedExtend = data.isAllowedExtend
      this.approversMain = data.detail.approvers

      let allStatus = []

      allStatus = allStatus.concat(data.detail.approvers)

      this.leaveExtends.forEach((el) => {
        el.approvers.forEach((item) => {
          item.extend = true
        })

        allStatus = allStatus.concat(el.approvers)
      })

      this.approvers = allStatus
    },
  },
}
